import { useEffect } from 'react';
import { ExternalLoggerFactory } from '../../api/createExternalLoggerFactory';
import { SubscribeToStateChanges, UnsubscribeFromStateChanges } from '../middleware/subscriptionMiddleware';
import { ConsoleLogger } from '../types';

export const useExternalLoggerClientInfo = ({
  consoleLogger,
  externalLoggerFactory,
  subscribeToStateChanges,
  unsubscribeFromStateChanges,
}: {
  consoleLogger: ConsoleLogger;
  externalLoggerFactory: ExternalLoggerFactory;
  subscribeToStateChanges: SubscribeToStateChanges;
  unsubscribeFromStateChanges: UnsubscribeFromStateChanges;
}) => {
  useEffect(() => {
    subscribeToStateChanges(function subscriber(state) {
      if (state.applicationStatus !== 'ready') {
        return;
      }

      const newClientInfo = {
        account: { externalId: state.account.externalId },
        productEnviroment: {
          cloudName: state.productEnvironment.cloudName,
          externalId: state.productEnvironment.externalId,
        },
        user: {
          email: state.user.email,
          externalId: state.user.externalId,
          role: state.user.role,
          technicalRole: state.user.technicalRole,
        },
        impersonationActive: state.isImpersonationActive,
      };

      externalLoggerFactory.updateClientInfo(newClientInfo);
      consoleLogger.debug('logger', 'Updated client info attached to logs', { newClientInfo });

      return () => unsubscribeFromStateChanges(subscriber);
    });
  }, [consoleLogger, externalLoggerFactory, subscribeToStateChanges, unsubscribeFromStateChanges]);
};
